import { useTranslation } from 'react-i18next'
import { useGenerationFormStore } from '../store'
import { CustomSelect } from '@/app/components/CustomSelect'
import { NumberInput } from '@/shared/components'

const SAMPLERS = [
  'euler', 'euler_ancestral', 'heun', 'heunpp2', 'dpm_2', 'dpm_2_ancestral',
  'lms', 'dpm_fast', 'dpm_adaptive', 'dpmpp_2s_ancestral', 'dpmpp_sde',
  'dpmpp_sde_gpu', 'dpmpp_2m', 'dpmpp_2m_sde', 'dpmpp_2m_sde_gpu',
  'dpmpp_3m_sde', 'dpmpp_3m_sde_gpu', 'ddpm', 'lcm', 'ddim', 'uni_pc',
  'uni_pc_bh2',
] as const

const SCHEDULERS = [
  'normal', 'karras', 'exponential', 'sgm_uniform', 'simple',
  'ddim_uniform', 'beta',
] as const

const SAMPLER_OPTIONS = SAMPLERS.map((s) => ({ value: s, label: s }))
const SCHEDULER_OPTIONS = SCHEDULERS.map((s) => ({ value: s, label: s }))

export function SamplerSettings() {
  const { t } = useTranslation()
  const samplerName = useGenerationFormStore((s) => s.samplerName)
  const scheduler = useGenerationFormStore((s) => s.scheduler)
  const steps = useGenerationFormStore((s) => s.steps)
  const cfgScale = useGenerationFormStore((s) => s.cfgScale)
  const seed = useGenerationFormStore((s) => s.seed)
  const setSamplerName = useGenerationFormStore((s) => s.setSamplerName)
  const setScheduler = useGenerationFormStore((s) => s.setScheduler)
  const setSteps = useGenerationFormStore((s) => s.setSteps)
  const setCfgScale = useGenerationFormStore((s) => s.setCfgScale)
  const setSeed = useGenerationFormStore((s) => s.setSeed)
  const isGenerating = useGenerationFormStore((s) => s.isGenerating)

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-tg-hint">
            {t('generate.sampler')}
          </label>
          <CustomSelect
            id="sampler-select"
            value={samplerName}
            onChange={setSamplerName}
            options={SAMPLER_OPTIONS}
            disabled={isGenerating}
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-tg-hint">
            {t('generate.scheduler')}
          </label>
          <CustomSelect
            id="scheduler-select"
            value={scheduler}
            onChange={setScheduler}
            options={SCHEDULER_OPTIONS}
            disabled={isGenerating}
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <NumberInput
          id="steps-input"
          label={t('generate.steps')}
          value={steps}
          onChange={setSteps}
          min={1}
          max={150}
          disabled={isGenerating}
        />
        <NumberInput
          id="cfg-input"
          label={t('generate.cfgScale')}
          value={cfgScale}
          onChange={setCfgScale}
          min={0}
          max={30}
          step={0.5}
          disabled={isGenerating}
        />
        <NumberInput
          id="seed-input"
          label={t('generate.seed')}
          value={seed}
          onChange={setSeed}
          min={-1}
          max={2147483647}
          disabled={isGenerating}
        />
      </div>
    </div>
  )
}
